import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const MessageUserIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M14.4 0H1.608c-.88 0-1.6.72-1.6 1.6L0 16l3.2-3.2h11.2c.88 0 1.6-.72 1.6-1.6V1.6c0-.88-.72-1.6-1.6-1.6Zm0 11.2H2.536l-.936.936V1.6h12.8v9.6ZM8 6.4c.88 0 1.6-.72 1.6-1.6 0-.88-.72-1.6-1.6-1.6-.88 0-1.6.72-1.6 1.6 0 .88.72 1.6 1.6 1.6Zm3.2 2.744c0-.648-.384-1.224-.976-1.48a5.56 5.56 0 0 0-4.448 0 1.609 1.609 0 0 0-.976 1.48V9.6h6.4v-.456Z" />
  </Icon>
);

export default memo(MessageUserIcon);
